import * as fromDatatype from '../datatype-library/index';
import * as fromDataype from "../datatype-library";

export interface app_filter_view_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  app_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  filter_hdr_guid: fromDatatype.GuidDataFieldInterface;
  target_hdr_guid: fromDatatype.GuidDataFieldInterface;
  target_table_name: fromDataype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  type: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class app_filter_view_RowClass implements app_filter_view_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  app_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  filter_hdr_guid: fromDatatype.GuidDataFieldInterface;
  target_hdr_guid: fromDatatype.GuidDataFieldInterface;
  target_table_name: fromDataype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  type: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}


